import LeadActionTypes from './lead.type';

const INITIAL_STATE = {
  allLeads: [],
  reloadLeads: false,
  reloadCustomers: false,
  reloadOpportunities: false,
  reloadQuotes: false,
  reloadJobs: false,
  reloadProspects: false,
};

const leadReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case LeadActionTypes.SET_LEAD: {
      return {
        ...state,
        allLeads: action.payload,
      };
    }
    case LeadActionTypes.RELOAD_LEAD: {
      return {
        ...state,
        reloadLeads: !state.reloadLeads,
      };
    }
    case LeadActionTypes.RELOAD_CUSTOMER: {
      return {
        ...state,
        reloadCustomers: !state.reloadCustomers,
      };
    }
    case LeadActionTypes.RELOAD_OPPORTUNITY: {
      return {
        ...state,
        reloadOpportunities: !state.reloadOpportunities,
      };
    }
    case LeadActionTypes.RELOAD_PROSPECTS: {
      return {
        ...state,
        reloadProspects: !state.reloadProspects,
      };
    }
    case LeadActionTypes.RELOAD_QUOTE: {
      return {
        ...state,
        reloadQuotes: !state.reloadQuotes,
      };
    }
    case LeadActionTypes.RELOAD_JOB: {
      return {
        ...state,
        reloadJobs: !state.reloadJobs,
      };
    }
    default:
      return state;
  }
};

export default leadReducer;
